export enum ServerToClientCommand {
  REPLY_CONNECT = 'REPLY_CONNECT',
  REPLY_JOIN = 'REPLY_JOIN',
  ASSIGN_AGENT = 'ASSIGN_AGENT',
  CONFIRM_REPLY_ASSIGN_AGENT = 'CONFIRM_REPLY_ASSIGN_AGENT',
  // REPLY_LEAVE = 'REPLY_LEAVE',//目前是前端通过api调用，后端api走的是websocket流程，前端可以根据api的结果处理
  WAITING_NO = 'WAITING_NO',
  NOTICE_LEAVE = 'NOTICE_LEAVE',
  VIDEO_CALL_START = 'VIDEO_CALL_START',

  FATAL_ERROR = 'FATAL_ERROR',
  PONG = 'PONG',
}

export enum WSCode {
  SUCCESS = 'SUCCESS',
  AGENT_INFO_STATE_ERROR = 'AGENT_INFO_STATE_ERROR',
  EXPIRED_TOKEN = 'EXPIRED_TOKEN',
  OPERATION_NOT_ALLOWED_ON_VIDEO_CALL = 'OPERATION_NOT_ALLOWED_ON_VIDEO_CALL',
}

export enum ClientCommand {
  CONNECT = 'CONNECT',
  JOIN = 'JOIN',
  LEAVE = 'LEAVE',
  PING = 'PING',
  STATISTICS = 'STATISTICS',
  REPLY_ASSIGN_AGENT = 'REPLY_ASSIGN_AGENT',
  REPLY_NOTICE_LEAVE = 'REPLY_NOTICE_LEAVE',
  VENDOR_ERROR = 'VENDOR_ERROR',
}

export enum ClientLeaveType {
  VENDOR_ERROR = 'VENDOR_ERROR',
  CLIENT_REPLY_TIMEOUT = 'CLIENT_REPLY_TIMEOUT',
}

export enum AgentLeaveType {
  AGENT_SUBMIT = 'AGENT_SUBMIT',
  AGENT_CANCEL = 'AGENT_CANCEL',
  VENDOR_ERROR = 'VENDOR_ERROR',
  AGENT_REPLY_TIMEOUT = 'AGENT_REPLY_TIMEOUT',
  NETWORK_DISCONNECTED = 'NETWORK_DISCONNECTED',
}

export interface IClientSocket {
  completeStatus: CompleteStatus;
  waitingNumber: number | string;
  mediaAccessCountdown: number;
  mediaAccessDialogClosed: boolean;
  videoCallInfo: IVideoCallInfo | null;
  videoCallStart: boolean;
  consentAgreed: boolean;
  callType: CallType;
  userConnectedBefore: boolean;
  clientReady: boolean;
}

export interface IVideoCallInfo {
  sessionId: string;
  token: string;
  apiKey: number;
  agentId?: number;
}

export enum CompleteStatus {
  SORRY = 'SORRY',
  THANKYOU = 'THANKYOU',
  MISSED = 'MISSED',
  AGENTISSUE = 'AGENTISSUE',
}

export enum CallType {
  IN = 'IN',
  OUT = 'OUT',
}
